<template>
  <div class="flex justify-between items-center border-2 p-4 mt-2">
    <div class="flex items-center">
      <input
        class="cursor-pointer"
        type="radio"
        :name="planName"
        :checked="isSelected"
        @click="selectPlanHandler"
      />
      <div class="ml-5">
        <p class="font-semibold">{{ planLabel }}</p>
        <p class="text-sm">Per player</p>

        <div
          v-if="hasTieredPricing && tieredPricingInfo"
          class="mt-2 text-xs text-gray-600"
        >
          <div class="flex flex-col items-start">
            <span>
              <span class="font-medium">Tier 1:</span>
              1-{{ getTierUpTo() }} players - ${{ getTier1Price().toFixed(2) }}
            </span>
            <span>
              <span class="font-medium">Tier 2:</span>
              {{ getTierUpTo() + 1 }}+ players - ${{
                getTier2Price().toFixed(2)
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="border-l-2 pl-2 text-sm text-gray-500">
      <p>Sub-total</p>
      <em v-if="loading" class="fa fa-spinner fa-spin ml-5"></em>
      <p v-else>USD {{ planPrice.toFixed(2) ?? 0 }}</p>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";

const props = defineProps({
  planName: { type: String, required: true },
  planLabel: { type: String, required: true },
  planPrice: { type: Number, default: 0 },
  isSelected: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  hasTieredPricing: { type: Boolean, default: false },
  tieredPricingInfo: { type: Array, default: null },
});

const PLAN_DURATIONS = {
  Month: "monthly",
  Semester: "semiannual",
  Year: "annual",
};

const emit = defineEmits(["selectPlan"]);

function selectPlanHandler() {
  emit("selectPlan", props.planName);
}

function getTierUpTo() {
  if (!props.hasTieredPricing || !props.tieredPricingInfo) {
    return 0;
  }

  const duration = PLAN_DURATIONS[props.planName];
  const tieredPrice = props.tieredPricingInfo.find(
    (price) => price.duration === duration
  );

  return tieredPrice ? tieredPrice.tier_1_up_to : 0;
}

function getTier1Price() {
  if (!props.hasTieredPricing || !props.tieredPricingInfo) {
    return 0;
  }

  const duration = PLAN_DURATIONS[props.planName];
  const tieredPrice = props.tieredPricingInfo.find(
    (price) => price.duration === duration
  );

  return tieredPrice ? Number(tieredPrice.price_tier_1) : 0;
}

function getTier2Price() {
  if (!props.hasTieredPricing || !props.tieredPricingInfo) {
    return 0;
  }

  const duration = PLAN_DURATIONS[props.planName];
  const tieredPrice = props.tieredPricingInfo.find(
    (price) => price.duration === duration
  );

  return tieredPrice ? Number(tieredPrice.price_tier_2) : 0;
}
</script>

<style scoped>
.border-2 {
  border-width: 2px;
}
</style>
